import React, { createContext, useState } from 'react';

type TabNodeContextValues = {
  node: HTMLElement | null;
  setNode: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
};

const TabNodeContext = createContext<TabNodeContextValues>({
  node: null,
  setNode: () => undefined
});

type TabNodeProviderProps = {
  children: React.ReactElement;
};

const TabNodeProvider = (props: TabNodeProviderProps): React.ReactElement => {
  const { children } = props;
  const [node, setNode] = useState<HTMLElement | null>(null);
  return <TabNodeContext.Provider value={{ node, setNode }}>{children}</TabNodeContext.Provider>;
};

export { TabNodeContext };
export default TabNodeProvider;
